import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import { Encrption } from "../app-modules/encrption";

const addFileDocumentTemplate = (fields) => {
  const data = {
    templateTypeId: fields.templateTypeId.id,
    templateName: fields.templateName,
    isHtmlFileTypeTemplate: fields.isFileTemplate,
    htmlFileName: fields.htmlFileName,
    isDefault: fields.isDefault,
    regionId: fields.regionName.id,
  };
  return ApiHelper.postRequest(API_URLS.INSERT_DOCUMENT_TEMPLATE, data);
};

const updateFileDocumentTemplate = (fields, state) => {
  const data = {};
  return ApiHelper.putRequest(API_URLS.UPDATE_CLINIC, data);
};

const GetAdminClinic = (id) => {
  return ApiHelper.getRequest(API_URLS.GET_ALL_ADMIN_CLINIC + Encrption(id));
};

const GetAdminDocument = (value) => {
  return ApiHelper.getRequest(
    API_URLS.GET_ADMIN_DOCUMENTS +
    Encrption(value.masterClinicId) +
    "&" +
    "adminClinicId" +
    "=" +
    value.id
  );
};

const getAllDefaultDocumentTemplates = (value) => {
  return ApiHelper.getRequest(
    API_URLS.GET_ALL_DEFAULT_DOCUMENT_TEMPLATES + Encrption(value.id)
  );
};

const markDocumentTemplateAsDefault = (fieldsInfo, fields) => {
  return ApiHelper.getRequest(
    API_URLS.GET_MARK_DOCUMENT_TEMPLATE_AS_DEFAULT +
    Encrption(fields.regionName.id) +
    "&" +
    "docTemplateId" +
    "=" +
    fieldsInfo.id
  );
};

const deleteClinic = (selectedId) => {
  return ApiHelper.deleteRequest(API_URLS.DELETE_CLINIC + selectedId.id);
};

const assignTemplate = (fields, documentTemplateId, sourceRegionId) => {
  const list = documentTemplateId.map((item) => item?.id)
  const data = {
    documentTemplateIds: list,
    clinicId: fields?.clinicName?.id,
    regionId: sourceRegionId?.regionName?.id,
  };
  return ApiHelper.postRequest(API_URLS.ASSIGN_TEMPLATE_TO_CLINIC, data);
};

const getAllClinic = () => {
  const data = {
    region: null,
    isActive: true,
    state: null,
    isRCM: null,
    customerStatusId: null,
  };

  return ApiHelper.postRequest(
    API_URLS.GET_ALL_CLINIC_BY_REGION,
    data
  );
};

const assignTemplateLabel = (label, documentTemplateId, regionId, checkedTemplates) => {
  let templateIdArray;
  if (documentTemplateId.id) {
    templateIdArray = [documentTemplateId.id];
  } else if (checkedTemplates) {
    templateIdArray = checkedTemplates.map(template => template.id);
  } else {
    templateIdArray = [];
  }
  const data = {
    templateId: templateIdArray,
    labelId: label?.id,
    regionId: regionId,
  };
  return ApiHelper.postRequest(API_URLS.POST_ASSIGN_LABEL_TO_DOCUMENT_TEMPLATE, data);
};

const removeTemplateLabel = ( documentTemplateId, regionId) => {
 
  const data = {
    templateId: [documentTemplateId],
    labelId: null,
    regionId: regionId,
  };
  return ApiHelper.postRequest(API_URLS.POST_ASSIGN_LABEL_TO_DOCUMENT_TEMPLATE, data);
};

const updateTemplate = (fields, documentTemplateId, regionId) => {
  const data = {
    templateId: documentTemplateId,
    templateName: fields?.templateName,
    htmlFileName: fields?.htmlFileName,
    templateTypeId: fields?.templateTypeId?.id,
    regionId: regionId
  }
  return ApiHelper.postRequest(API_URLS.UPDATE_DOCUMENT_TEMPLATE, data)
}

const addDocumentTemplateTags = (fields, tagColor) => {
  const data = {
    id: 0,
    labelName: fields?.labelName,
    labelColor: tagColor
  }
  return ApiHelper.postRequest(API_URLS.INSERT_UPDATE_DOCUMENT_TEMPLATE_LABEL, data)
}

const editDocumentTemplateTags = (fields, tagColor, selectedTag) => {
  const data = {
    id: selectedTag?.id,
    labelName: fields?.labelName,
    labelColor: tagColor
  }
  return ApiHelper.postRequest(API_URLS.INSERT_UPDATE_DOCUMENT_TEMPLATE_LABEL, data)
}

const getDocumentTemplateTagList = (value) => {
  return ApiHelper.getRequest(API_URLS.GET_DOCUMENT_TEMPLATE_LABELS + Encrption(value?.id));

}
const deleteDocumentTemplateTag = (selected) => {
  return ApiHelper.deleteRequest(API_URLS.DELETE_DOCUMENT_TEMPLATE_LABEL + Encrption(selected?.id));

}

const unassignDocumentTemplate = (selectedId, regionId, selectedTemplateInfo) => {
  return ApiHelper.deleteRequest(API_URLS.UNASSIGN_DOCUMENT_TEMPLATE + regionId + '&masterClinicId=' + selectedId + '&documentTemplateId=' + selectedTemplateInfo?.id);
}

export const fileDocumentService = {
  addFileDocumentTemplate,
  GetAdminClinic,
  deleteClinic,
  updateFileDocumentTemplate,
  assignTemplate,
  GetAdminDocument,
  markDocumentTemplateAsDefault,
  getAllDefaultDocumentTemplates,
  getAllClinic,
  assignTemplateLabel,
  updateTemplate,
  addDocumentTemplateTags,
  editDocumentTemplateTags,
  getDocumentTemplateTagList,
  deleteDocumentTemplateTag,
  unassignDocumentTemplate,
  removeTemplateLabel
};
